import React from 'react';
import Box from '@cashew/box';
import Title from '@cashew/title';
import List from '@cashew/list';
import { ChargebackListProps } from './index.types';
import ChargebackItem from './ChargebackItem';

const ChargebackList = ({
  ns,
  chargebacks,
  showTransactionDetails,
  t,
}: ChargebackListProps) => (
  <>
    <Title>Chargebacks</Title>
    <Box withHeader className={`${ns}__box`}>
      <div>
        <div className={`${ns}__headers`}>
          <p>Chargeback date</p>
          <p>Installments</p>
          <p>Payment date</p>
          <p>Payment amount</p>
          <p>Status</p>
          <p>Auth code</p>
          <p>ARN</p>
          <p style={{ flexGrow: 5 }}>Actions</p>
        </div>
        <List
          component={ChargebackItem}
          data={chargebacks}
          onClick={showTransactionDetails}
          t={t}
        />
      </div>
    </Box>
  </>
);

export default ChargebackList;
